import { PageContainer } from '@ant-design/pro-components';
import { Button, Card, Result } from 'antd';
import { Link } from 'react-router-dom';
import { useOrganizationPath } from '@/common/hooks/use-organization-path';

export default () => {
  const { resolveOrganizationPath } = useOrganizationPath();
  return (
    <PageContainer pageHeaderRender={false}>
      <Card variant="borderless">
        <Result
          status="403"
          title="403"
          subTitle="Sorry, you are not authorized to access this page."
          extra={
            <Link to={resolveOrganizationPath('/')}>
              <Button type="primary">Back to home</Button>
            </Link>
          }
        />
      </Card>
    </PageContainer>
  );
};
